import { FlexComp, FormattedText, ImageComponent, SpanTag } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { theme } from "@tm/utility/global";
import React from "react";

import type { TextNodeType } from "../../../../components/FormattedText/FormattedText";
import { OrderDataIconWrapper } from "./OrderDetailV2OrderData.style";

export interface OrderDataHeaderProps {
  insPlanName?: string | TextNodeType;
  orderDetailIcon?: string;
  insuranceInfo?: string | TextNodeType;
  insuranceType?: string | TextNodeType;
  insuranceTypeColor?: string;
}

export const OrderDataHeader: React.FC<OrderDataHeaderProps> = ({
  insPlanName,
  orderDetailIcon,
  insuranceInfo,
  insuranceType,
  insuranceTypeColor,
}) => {
  const device = useBreakpointV2();

  return (
    <FlexComp flexDirection="row" justifyContent="space-between" gap="8px">
      <FlexComp flexDirection="column" gap="2px" margin="0">
        <SpanTag fontSize={device === "lg" ? "large" : "md"} fontWeight="bold">
          <FormattedText value={insPlanName} />
        </SpanTag>
        <SpanTag
          fontSize={device === "lg" ? "sm" : "xs"}
          color={theme.greyText}
          margin="0 16px 0 0"
        >
          <FormattedText value={insuranceInfo} />
          <SpanTag
            fontSize="xs"
            fontWeight="bold"
            textTransform="uppercase"
            color={insuranceTypeColor}
          >
            <FormattedText value={insuranceType} />
          </SpanTag>
        </SpanTag>
      </FlexComp>

      {orderDetailIcon && (
        <OrderDataIconWrapper>
          <ImageComponent width="56px" height="56px" src={orderDetailIcon} />
        </OrderDataIconWrapper>
      )}
    </FlexComp>
  );
};
